import React, { useState, useEffect } from "react";
import { Form, Button, Col, Row, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { getAllUsers } from "../api/getAllUser";
import { ToastContainer } from "react-toastify";
import { Card } from "react-bootstrap";
import Loader from "../components/Loader/Loader";
import { getDiet } from "../api/getDiet";
import { getAllDiet } from "../api/getAllDiet";
import { deleteDiet } from "../api/deleteDiet";
import DietPlanModal from "../components/DietPlanModal/DietPlanModal";
import { createDiet } from "../api/createDiet";
import { toast } from 'react-toastify';
import moment from "moment";

const MealCard = ({ meal, onDelete }) => {
  const { title, date, content, _id, createdFor } = meal;

  return (
    <Card style={{ margin: "20px", padding: "10px", position: "relative" }}>
      <Card.Body>
        <i
          className={"fa fa-trash"}
          onClick={() => onDelete(_id)}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            cursor: "pointer",
            color: "#dc3545",
          }}
        ></i>
        <Card.Title>{title}</Card.Title>
        <Card.Subtitle className="mb-2 text-muted">
          {new Date(date).toDateString()}
          {createdFor?.name ? ' - Created for: ' + createdFor?.name : ''}
        </Card.Subtitle>
        <div>
          {content.map((item, index) => (
            <p key={index} style={{ height: 20, textOverflow: 'clip', overflow: 'hidden' }}>
              {item}
            </p>
          ))}
        </div>
      </Card.Body>
    </Card>
  );
};

const DietScreen = ({ onSubmit }) => {
  const [userId, setUserId] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedId, setSelectedId] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const selectAllOption = { label: "Select All", value: "Select All" };
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() + 1);

  const [dateRange, setDateRange] = useState([currentDate, currentDate]);
  const [allUsers, setAllUsers] = useState([]);
  const [meals, setMeals] = useState([]);
  const [errors, setErrors] = useState({});
  const handleDelete = () => {
    deleteDiet(selectedId);
    setMeals(meals.filter((meal) => meal._id !== selectedId));
    setShowModal(false);
  };
  const [showCreateModal, setShowCreateModal] = useState(false);

  const handleShow = () => setShowCreateModal(true);
  const handleClose = () => setShowCreateModal(false);

  const handleCreateSubmit = async (payload) => {
    handleClose();
    const res = await createDiet(payload)
    if (res?.message) {
      toast.success(res?.message)
    } else {
      toast.error(res?.message || 'Issue on creating diet')
    }
  };

  useEffect(() => {
    const fetchAllUsers = async () => {
      try {
        setIsLoading(true);
        const response = await getAllUsers();
        if (!response.some((item) => item.value === selectAllOption.value)) {
          response.unshift(selectAllOption);
        }
        setAllUsers(response);
      } catch (error) {
        console.log(error.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAllUsers();
  }, []);

  const validateForm = () => {
    const errors = {};
    if (userId.length === 0)
      errors.userId = "At least one user must be selected.";
    if (!dateRange[0] || !dateRange[1])
      errors.dateRange = "Date range is required.";
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (!validateForm()) return;
    const isInArray = userId.some((obj) => obj.value === "Select All");
    let newArray = [];
    if (allUsers[0].value === "Select All") newArray = allUsers.slice(1);
    const fromDate = new Date(dateRange[0]);
    fromDate.setDate(fromDate.getDate());
    const toDate = new Date(dateRange[1]);
    toDate.setDate(toDate.getDate());
    const formData = {
      userId: !isInArray
        ? userId.map((user) => user.value)
        : newArray.map((user) => {
          return user.value;
        }),
      fromDate: moment(fromDate).format('YYYY-MM-DD'),
      toDate: moment(toDate).format('YYYY-MM-DD'),
    };

    try {
      const res = isInArray
        ? getAllDiet(formData).then((val) => {
          setMeals(val.reverse());
        })
        : getDiet(formData, fromDate, toDate).then((val) => {
          setMeals(val.reverse());
        });
    } catch (error) {
      console.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  function setUserOnChange(newSelectedOptions) {
    setUserId([newSelectedOptions]);
    setErrors({});
  }
  if (isLoading) return <Loader></Loader>;
  return (
    <div className="">
      <Form onSubmit={handleSubmit}>
        <Row className="align-items-center">
          <Col>
            <h1>Diet</h1>
          </Col>
          <Col className="text-right">
            <Button className="my-3" onClick={handleShow}>
              Create
            </Button>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <Form.Group controlId="userId">
              <Row>
                <Form.Label>To</Form.Label>
                <Select
                  options={allUsers}
                  value={userId}
                  onChange={setUserOnChange}
                  placeholder="Select Users"
                />
                {errors.userId && (
                  <Form.Text className="text-danger">{errors.userId}</Form.Text>
                )}
              </Row>
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="dateRange">
              <Row>
                <Form.Label>Date Range</Form.Label>
                <DatePicker
                  selectsRange
                  minDate={currentDate}
                  startDate={dateRange[0]}
                  endDate={dateRange[1]}
                  onChange={(update) => setDateRange(update)}
                  isClearable={true}
                  placeholderText="Select date range"
                  className="form-control"
                />
                {errors.dateRange && (
                  <Form.Text className="text-danger">
                    {errors.dateRange}
                  </Form.Text>
                )}
              </Row>
            </Form.Group>
          </Col>
        </Row>
        <Button variant="primary" type="submit">
          Submit
        </Button>
      </Form>
      <div>
        {meals?.map((meal) => (
          <MealCard
            key={meal._id}
            meal={meal}
            onDelete={(id) => {
              setShowModal(true);
              setSelectedId(id);
            }}
          />
        ))}
      </div>

      <Modal show={showModal} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete?</Modal.Body>
        <Modal.Footer className="flex-column">
          <Button variant="secondary" onClick={closeModal}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showModal} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete?</Modal.Body>
        <Modal.Footer className="flex-column">
          <Button variant="secondary" onClick={closeModal}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
      <DietPlanModal
        users={allUsers}
        show={showCreateModal}
        handleClose={handleClose}
        handleSubmit={handleCreateSubmit}
      />
      <ToastContainer />
    </div>
  );
};

export default DietScreen;
